export default [
  {
    text: 'sync.table.id',
    value: 'id',
    default: true,
    align: 'left',
  },
  {
    text: 'sync.table.name',
    value: 'name',
    default: true,
    align: 'left',
  },
];
